import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'


export function columnsXS(columnOption) {
    return ([
        {
            dataField: 'id',
            text: 'Seleccionados',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Nombre:' value={row.name} />
                        <TableRowField label='Cantidad:' value={row.quantity} />
                        <TableRowField label='Precio Unitario (S/):' value={formatHelper.toMoney(row.before_price)} />
                        <TableRowField label='Descuento Unitario (S/):' value={formatHelper.toBlankUnitDiscount(row.unit_discount, row.type_unit_discount)} />
                        <TableRowField label='Precio Total (S/):' value={formatHelper.toMoney(row.price)} />
                    </div>
                )
            }
        },
        columnOption
    ])
}
export function columnsSM(columnOption) {
    return ([
        {
            dataField: 'name',
            text: 'Nombre',
            formatter: (cell) => {
                return (
                    <span>{cell}</span>
                )
            }
        },
        {
            dataField: 'quantity',
            text: 'Cantidad',
            formatter: (cell) => {
                return (
                    <span>{cell}</span>
                )
            }
        },
        {
            dataField: 'before_price',
            text: 'Precio Unitario (S/)',
            formatter: (cell) => {
                return (
                    <span>{formatHelper.toMoney(cell)}</span>
                )
            }
        },
        {
            dataField: 'unit_discount',
            text: 'Descuento Unitario (S/)',
            formatter: (cell, row) => {
                return (
                    <span>{formatHelper.toBlankUnitDiscount(cell, row.type_unit_discount)}</span>
                )
            }
        },
        {
            dataField: 'price',
            text: 'Precio Total (S/)',
            formatter: (cell) => {
                return (
                    <span>{formatHelper.toMoney(cell)}</span>
                )
            }
        },
        columnOption
    ])
}

export function columns(columnOption) {
    return ([
        {
            dataField: 'name',
            text: 'Nombre',
            formatter: (cell) => {
                return (
                    <span>{cell}</span>
                )
            }
        },
        {
            dataField: 'quantity',
            text: 'Cantidad',
            formatter: (cell) => {
                return (
                    <span>{cell}</span>
                )
            }
        },
        {
            dataField: 'before_price',
            text: 'Precio Unitario (S/)',
            formatter: (cell) => {
                return (
                    <span>{formatHelper.toMoney(cell)}</span>
                )
            }
        },
        {
            dataField: 'unit_discount',
            text: 'Descuento Unitario (S/)',
            formatter: (cell, row) => {
                return (
                    <span>{formatHelper.toBlankUnitDiscount(cell, row.type_unit_discount)}</span>
                )
            }
        },
        {
            dataField: 'price',
            text: 'Precio Total (S/)',
            formatter: (cell) => {
                return (
                    <span>{formatHelper.toMoney(cell)}</span>
                )
            }
        },
        columnOption
    ])
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationAdd/_columns.js